import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const parameterService = createApi({
  reducerPath: 'parameterService',
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ['Parameter', 'ParameterCategory'],
  endpoints: (builder) => ({
    getAllParameter: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.parameterController.getAllParameter}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    saveParameter: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterController.saveParameter}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    updateParameter: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterController.updateParameter}/${body.id}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    deleteParameter: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterController.deleteParameter}/${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    getAllParameterWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.parameterController.getAllParameterWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getAllParameterCategory: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.parameterCategoryController.getAllParameterCategory}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    saveParameterCategory: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterCategoryController.saveParameterCategory}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    updateParameterCategory: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterCategoryController.updateParameterCategory}/${body.id}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    deleteParameterCategory: builder.mutation({
      query(body){
        return {
          url: `${userManagement.parameterCategoryController.deleteParameterCategory}/${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    getAllParameterCategoryWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.parameterCategoryController.getAllParameterCategoryWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
  })
});

export const {
  useGetAllParameterMutation,
  useSaveParameterMutation,
  useUpdateParameterMutation,
  useDeleteParameterMutation,
  useGetAllParameterWithSearchMutation,
  useGetAllParameterCategoryMutation,
  useSaveParameterCategoryMutation,
  useUpdateParameterCategoryMutation,
  useDeleteParameterCategoryMutation,
  useGetAllParameterCategoryWithSearchMutation,
} = parameterService;
